import { format } from 'date-fns';

enum UserRolesToServer {
  admin = 1,
  teacher = 2,
  student = 3,
  mentor = 4,
  accountant = 5,
  sales_managers = 6,
  sales_admin = 7,
}

enum UserRoles {
  admin = 'admins',
  teacher = 'teachers',
  student = 'students',
  mentor = 'mentors',
  sales_admin = 'sales_admin',
  sales_managers = 'sales_managers',
  accountant = 'accountant',
  companies = 'companies',
}

enum StudentStatus {
  active = 'active',
  inactive = 'inactive',
  deactivated = 'deactivated',
  debtors = 'debtors',
}

enum ProfileTabsNames {
  myGroups = 'myGroups',
  lastMaterials = 'lastMaterials',
  upcomingEvents = 'upcomingEvents',
}

enum StudentHomeworkOrExamStatus {
  UPLOADED = 'Сдана',
  NOT_UPLOADED = 'Не сдана',
  IN_REVIEW = 'В проверке',
  REVIEWED = 'Проверена',
}

enum DateAndTimeFormats {
  dayMonthYear_hourMinutes = 'dd.MM.yyyy | HH:mm',
  dayMonthYear = 'dd.MM.yyyy',
}

enum PaginationSettings {
  maxPageSize = 10,
}

enum StudentsWorksStatuses {
  UPLOADED = 'UPLOADED',
  IN_REVIEW = 'IN_REVIEW',
  REVIEWED = 'REVIEWED',
  SUPPORT_DEADLINE = 'SUPPORT_DEADLINE',
}

enum StudentsNoteTypes {
  EXPULSION = 'expulsion',
  BLOCKING = 'blocking',
  ESDP = 'esdp',
  OTH = 'oth',
}

enum SidebarSettings {
  sidebarSpawnWidth = 988,
}

enum EventTypes {
  LESS = 'Лекция',
  EXAM = 'Контрольная',
  WEB = 'Вебинар',
  ESDP_LESS = 'Лекция ESDP',
  OTH = 'Другое',
}

enum ESDPTimes {
  '12:00-15:00' = '1',
  '15:00-18:00' = '2',
  '18:00-21:00' = '3',
}

enum ESDPRoles {
  captain = 'Капитан',
  analyst = 'Аналитик',
  developer = 'Разработчик',
}

enum UIThemes {
  dark = 'dark',
  light = 'light',
}

enum HowHearAboutUsForSalesEnrolleeForm {
  TWO_GIS = '2ГИС',
  INSTAGRAM = 'Инстаграм',
  FROM_ACQUAINTANCES = 'От знакомых',
  FROM_CONSULTATION = 'На консультации',
}

enum LeadApplicationSource {
  OFFICE = 'Офис',
  REQUEST_FOR_PRESENTATION = 'Заявки презентации',
  RE_APPLY_FOR_PRESENTATION = 'Повторная заявка на презентацию',
  SOCIAL_NETWORK = 'Социальные сети',
  WEBSITE = 'Сайт',
}

enum CompanyFaces {
  OF = 'Общественный фонд',
  OSOO = 'ОcОО',
}

enum SalesTaskStatuses {
  NEW = 'Новая',
  IN_PROGRESS = 'В работе',
  DONE = 'Готово',
}

enum SalesTaskStatusesColorsClasses {
  NEW = 'lightBlue',
  IN_PROGRESS = 'lightYellow',
  DONE = 'lightGreen',
}

enum lessonsDay {
  '1-4' = 'Понедельник-Четверг',
  // '1-5' = "Понедельник-Пятница",
  // '2-4' = "Вторник-Четверг",
  '2-5' = 'Вторник-Пятница',
  // '2-6' = "Вторник-Суббота",
  // '3-5' = "Среда-Пятница",
  // '3-6' = "Среда-Суббота",
}

export const allListOfLessonsDay = {
  '1-4': 'Понедельник-Четверг',
  '1-5': 'Понедельник-Пятница',
  '2-4': 'Вторник-Четверг',
  '2-5': 'Вторник-Пятница',
  '2-6': 'Вторник-Суббота',
  '3-5': 'Среда-Пятница',
  '3-6': 'Среда-Суббота',
  '1': 'Понедельник',
  '2': 'Вторник',
  '3': 'Среда',
  '4': 'Четверг',
  '5': 'Пятница',
  '6': 'Суббота',
};

enum lessonsFormat {
  ONLINE = 'Онлайн',
  OFFLINE = 'Офлайн',
}

enum SalesPaymentType {
  CARD = 'Карта',
  CASH = 'Нал.',
  POS_TERMINAL = 'Пос-терминал',
  BANK = 'Банк',
}

enum SaLesPaymentStatus {
  PAID = 'Оплачено',
  PARTIALLY_PAID = 'Частично оплачено',
  UNPAID = 'Не оплачено',
}

enum DiscountsType {
  FRIEND = 'Скидка за друга',
  ACADEMIC_PERFORMANCE = 'Скидка за хорошую успеваемость',
  PRESENTATION = 'Скидка от спикера',
  CERTIFICATE = 'Скидка за сертификат',
  OTHER = 'Другое',
}

export class GlobalConstants {
  static readonly UserRolesToServer = UserRolesToServer;
  static readonly UserRoles = UserRoles;
  static readonly StudentStatus = StudentStatus;
  static readonly ProfileTabsNames = ProfileTabsNames;
  static readonly SidebarSettings = SidebarSettings;
  static readonly EventTypes = EventTypes;
  static readonly StudentHomeworkOrExamStatus = StudentHomeworkOrExamStatus;
  static readonly PaginationSettings = PaginationSettings;
  static readonly StudentsWorksStatuses = StudentsWorksStatuses;
  static readonly SalesTaskStatusesColorsClasses =
    SalesTaskStatusesColorsClasses;
  static readonly DateAndTimeFormats = DateAndTimeFormats;
  static readonly StudentsNoteTypes = StudentsNoteTypes;
  static readonly ESDPTimes = ESDPTimes;
  static readonly ESDPRoles = ESDPRoles;
  static readonly UIThemes = UIThemes;
  static readonly HowHearAboutUs = HowHearAboutUsForSalesEnrolleeForm;
  static readonly LeadApplicationSource = LeadApplicationSource;
  static readonly CompanyFaces = CompanyFaces;
  static readonly SalesTaskStatuses = SalesTaskStatuses;
  static readonly lessonsDay = lessonsDay;
  static readonly SalesPaymentType = SalesPaymentType;
  static readonly SaLesPaymentStatus = SaLesPaymentStatus;
  static readonly lessonsFormat = lessonsFormat;
  static readonly DiscountsType = DiscountsType;
  static readonly dateFormat = format(new Date(), 'yyyy-MM-dd');

  static readonly DEFAULT_DATEPICKER_FORMAT = {
    parse: {
      dateInput: 'YYYY.MM.DD', // как парсить ввод
    },
    display: {
      dateInput: 'DD.MM.YYYY', // как отображать в инпуте
      monthYearLabel: 'MMMM YYYY', // заголовок в календаре
    },
  };

  static readonly ONLY_LETTERS =
    /^[^0-9!@"~`#№;$%^:&?*()/\-_=+\]\[{}|\\'<>.,]+$/; // eslint-disable-line
  static readonly ONLY_SYMBOL = /[0-9!@"~`#№;$%^:&?*()\-_=+}/|{\[\]\\'<>.,]/g; // eslint-disable-line
  static ALMATY_BASE_URL = 'https://almaty-crm-api.attractor-school.com/';

  static readonly MOUNTHLY_PAYMENT = 21000;
}
